
export default {

  dealImg(img, style = 'pre_view') {
    if (img == null || img == undefined) return null;
    if (typeof img == 'string') {
      img = img.replace("files.eshangying.com", "esyfiles.jianyingkeji.com");
      img = img.replace("i.ebayimg.com", "images.weserv.nl/?url=https://i.ebayimg.com");
    }
    if (img.indexOf('jianyingkeji.com') < 0) return img;
    img = img.replace("http://", "https://");
    return img + '?x-oss-process=style/' + style;
  },

  firstImg(imgArr = []) {
    return this.dealImg(imgArr[0], 'thumbnail_first');
  },

  imgArr(imgArr = []) {
    if (!imgArr) return null;
    for (let i = 0; i < imgArr.length; i++) {
      imgArr[i] = this.dealImg(imgArr[i], 'pre_view')
    }
    return imgArr;
  },

}
